import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FC } from 'react';
import { AiOutlineArrowRight } from 'react-icons/ai';

const SupplyChainConnectorBg: FC<
  React.PropsWithChildren<SupplyChainConnectorBgProps>
> = ({ children, last, index }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.supplyChainConnectorBg}>
      <div className={classes.content}>
        <div className={classes.bg} />
        <div className={classes.end}>
          {!last && (
            <AiOutlineArrowRight
              className={classes.arrow}
              data-testid={`bg-arrow-${index}`}
            />
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  supplyChainConnectorBg: {
    height: '100%',
    paddingInlineEnd: 20,
  },
  content: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  end: {
    width: 20,
    height: 20,
    position: 'absolute',
    left: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  bg: {
    position: 'absolute',
    width: '100%',
    top: '50%',
    transform: 'translateY(-50%)',
    flexGrow: 1,
    borderBottom: `2px dotted ${theme.palette.divider}`,
  },
  arrow: {
    color: theme.palette.divider,
    width: 20,
    height: 20,
  },
}));

interface SupplyChainConnectorBgProps {
  last?: boolean;
  index: number;
}

export default SupplyChainConnectorBg;
